export default ({ inputEl, limitEl, maxLength }) => {
  limitEl.innerHTML = `${maxLength - inputEl.value.length} ${window.__PAGE_VARS__.translations.remainingChars}`
}
